import { NativeModule, requireNativeModule } from "expo";

export type EsimInstallResult = {
  status: "success";
  message: string;
};

export type EsimInfo = {
  displayName: string;
  carrierName: string;
  isActive: boolean;
  subscriptionId: number;
  countryIso: string;
};

export type EsimInstallError = {
  code:
    | "INVALID_ACTIVATION_CODE"
    | "PROFILE_ALREADY_EXISTS"
    | "NETWORK_ERROR"
    | "SERVER_ERROR"
    | "INVALID_SERVER_RESPONSE"
    | "AUTHENTICATION_ERROR"
    | "PROFILE_NOT_FOUND"
    | "INSUFFICIENT_STORAGE"
    | "RESOLVABLE_ERROR"
    | "GENERAL_ERROR"
    | "ESIM_ERROR"
    | "USER_CANCELED"
    | "UNKNOWN_ERROR"
    | "UNSUPPORTED_ERROR"
    | "INSTALL_ERROR"
    | "AMBIGUOUS_RESULT"
    // Códigos de operação + erro
    | "SYSTEM_CARRIER_LOCKED"
    | "SYSTEM_INVALID_ACTIVATION_CODE"
    | "SYSTEM_TIMEOUT"
    | "SIM_SLOT_CARRIER_LOCKED"
    | "SIM_SLOT_TIMEOUT"
    | "SIM_SLOT_EUICC_MISSING"
    | "EUICC_CARD_UNSUPPORTED_VERSION"
    | "EUICC_CARD_EUICC_MISSING"
    | "SWITCH_CARRIER_LOCKED"
    | "DOWNLOAD_CARRIER_LOCKED"
    | "DOWNLOAD_INVALID_ACTIVATION_CODE"
    | "DOWNLOAD_INCOMPATIBLE_CARRIER"
    | "DOWNLOAD_OPERATION_BUSY"
    | "METADATA_INVALID_ACTIVATION_CODE"
    | "METADATA_INCOMPATIBLE_CARRIER"
    | "EUICC_GSMA_INSTALL_FAILED"
    | "EUICC_GSMA_INSUFFICIENT_MEMORY"
    | "EUICC_GSMA_DISALLOWED_BY_PPR"
    | "HTTP_CONNECTION_ERROR"
    | "UNKNOWN_OPERATION_UNKNOWN_ERROR";
  message: string;
};

declare class ExpoEsimManagerModule extends NativeModule {
  isEsimSupported(): boolean;
  getInstalledEsims(): EsimInfo[];
  diagnosticInfo(): Record<string, any>;
  install(params: { activationCode: string }): Promise<EsimInstallResult>;
  scanQrCode(): Promise<EsimInstallResult>;
}

// This call loads the native module object from the JSI.
export default requireNativeModule<ExpoEsimManagerModule>("ExpoEsimManager");
